import { configureStore } from "@reduxjs/toolkit";
import patientlistSlice from "./slices/Patients/patientlistSlice";
import loginSlice from "./slices/authentication/login";
import forgotPassword from "./slices/authentication/forgotPassword";
import verifyEmail from "./slices/authentication/verifyEmail";
import resetPassword from "./slices/authentication/resetPassword";
import kcDcmTokenSlice from './slices/authentication/kc-dcm-token';
import localKcDcmTokenSlice from './slices/authentication/local-kc-dcm-token';
import patientdetailSlice from "./slices/Patients/patientdetailSlice";
import addEditAppointmentSlice from "./slices/Appointment/addEditAppointmentSlice";
import latestModalitySlice from "./slices/Appointment/latestModalitySlice";
import preappointmentSlice from "./slices/Patients/preappointmentSlice";
import prescriptionListSlice from "./slices/Patients/patientPrescriptionListSlice";
import prescriptionUploadSlice from "./slices/Patients/prescriptionUploadSlice";
import prescriptionDeleteSlice from "./slices/Patients/prescriptionDeleteSlice";
import healthcareUpdateSlice from "./slices/Patients/healthcareUpdateSlice";
import patientStudiesSlice from "./slices/Patients/patientStudiesSlice";
import getUserDetails from "./slices/user/getUserDetails";
import changePasswordSlice from "./slices/user/changePassword";
import updateProfile from "./slices/user/updateProfile";
import auditListSlice from "./slices/Audit/auditListSlice";
import hospitalDetails from "./slices/hospital/hospitalDetails";
import reportSlice from "./slices/report/reportSlice";
import rollbackListSlice from "./slices/report/rollbackListSlice";
import toggleOverlaySlice from "./slices/ToggleOverlay/toggleOverlay";
import appointmentDetailSlice from "./slices/Appointment/appointmentDetailSlice";
import getReportIdSlice from "./slices/report/getReportIdSlice";
import reportsSettingsSlice from "./slices/report/reportsSettings";
import verifyReportSlice from './slices/report/verifyReportSlice';
import verifyTelepathologyReportSlice from './slices/report/verifyTelepathologyReportSlice';
import updateProfileImageSlice from "./slices/report/updateProfileImage";
import submitReportsSettingsForm from "./slices/report/submitReportsSettingsForm";
import ActiveMachinelistSlice from "./slices/Activmachine/ActiveMachinelistSlice";
import addActiveMachineSlice from './slices/Activmachine/addactivemachineSlice';
import teleraidologyCustomerSlice from "./slices/teleradiologycustomer/teleraidologyCustomerSlice";
import discardReportSlice from "./slices/report/discardReport";
import updateTags from "./slices/updateTags";
import studyDataSlice from './slices/DCM4CHEE/studyDataSlice'
import teleraidologySlice from './slices/teleradiologycustomer/teleraidologyCustomerSlice';
import duplicateStudySlice from './slices/DCM4CHEE/duplicateSlice'

import listStudyResearchSlice from "./slices/StudyResearch/studyResearchListSlice"
import updateStudyResearchSlice from "./slices/StudyResearch/updateStudyResearchSlice";
import addStudyResearchSlice from './slices/StudyResearch/addStudyResearchSlice';
import radiologiestUserSlice from "./slices/radiologiestUser/radiologiestUserSlice";
import sendReviewSlice from "./slices/radiologiestUser/sendReviewSlice";
import reviewSlice from './slices/myworklist/myworklistSlice';
import sendBackSlice from "./slices/myworklist/sendBackSlice";
import getRadiologistUserSlice from './slices/radiologiestUser/getRadiologistUserSlice';
import assignRadiologistSlice from './slices/radiologiestUser/assignRadiologistSlice';
import pathologistUserSlice from './slices/pathologiestUser/pathologiestUserSlice';
import assignPathologistSlice from './slices/pathologiestUser/assignPathologistSlice';
import teleradiologistSlice from './slices/teleradiologist/getTeleradiologist';
import dashboardSlice from './slices/dashboard/dashboard';
import getRollbackReportSlice from './slices/report/ReportDetailsSlice';
import getAllReportSlice from "./slices/report/getAllReportSlice";
import shareReportWhatsappSlice from "./slices/report/shareReportWhatsappSlice";
import userListSlice from "./slices/user/getUserList";
import deleteUserSlice from "./slices/user/deleteUser";
import deletePatientSlice from "./slices/Patients/deletePatientSlice";
import addEditPACSlice from "./slices/Setting/addEditPacSlice";
import deleteMachineSlice from "./slices/Activmachine/deleteMachineSlice";
import getSharedReportSlice from "./slices/report/sharedDetailsSlice";
import reportImageSelectionSlice from './slices/report/imageSelectionSlice';
import aiImageSelectionSlice from './slices/report/aiImageSelectionSlice';
import machineApiSlice from './slices/machine/addMachine';
import getMachineListApiSlice from './slices/machine/getMachineList';
import deleteSelectedMachineSlice from './slices/machine/deleteMachine';
import EditMachineApiSlice from './slices/machine/editMachine';
import getDeviceNameSlice from './slices/machine/getDevice';
import deactivateUserSlice from './slices/user/deactivateUser';
import activateUserSlice from './slices/user/activateUser';
import deactivatePatientSlice from './slices/Patients/deactivatePatient';
import activatePatientSlice from './slices/Patients/activatePatient';
import deactivateRadiologistUserSlice from './slices/user/deactivateRadiologistUser';
import uploadReportImgsSlice from './slices/report/uploadReportImgsSlice';
import uploadImageMicroscopySlice from './slices/Microscopy/index';
import patientMicroscopyDetailSlice from './slices/Microscopy/patientMicroscopicSlice';
import saveMicroscopyMeasurementsSlice from './slices/Microscopy/saveMeasurementSlice';
import getMicroscopyMeasurementsSlice from './slices/Microscopy/getMeasurementSlice';
import updateMicroscopyMeasurementsSlice from './slices/Microscopy/updateMeasurementSlice';
import addEditPriceSlice from './slices/price/addEditPrice';
import editPriceSlice from "./slices/price/editPrice";
import getPriceSlice from './slices/price/getPrice';
import addEditModalityStudySlice from './slices/modalityStudyRegion/addEditModalityStudy';
import getModalityStudySlice from './slices/modalityStudyRegion/getModalityStudy';
import getModifiedCreditHospitalsSlice from './slices/modalityStudyRegion/getModifiedCreditHospitals';
import deletePriceSlice from './slices/price/deletePrice';
import deleteMicroscopyAnnotationSlice from './slices/Microscopy/deleteAnnotationSlice'
import redoScanSlice from './slices/redo/redoScan';
import deletePreviewImageSlice from './slices/report/deletePreviewImageSlice';
import addRedoReasonSlice from './slices/redo/addReason';
import getAppointmentStudySlice from './slices/Appointment/getAppointmentStudy';
import getNotificationCountSlice from './slices/report/notificationCount';
import saveProcessedReportsSlice from './slices/report/saveProcessedReport';
import previewReportDownloadSlice from './slices/report/previewReportDownload';
import updateReportSlice from './slices/report/updateReportSlice';

import createIsoImageSlice from './slices/Media-service/mediaServiceSlice'
import verifyStudyLinkSlice from './slices/Media-service/verifyStudyLinkSlice'
import geneateStudyLinkSlice from './slices/Media-service/generateStudyLinkSlice'

import dwnldImgSlice from './slices/DCM4CHEE/dwnldImgSlice';
import copyImgSlice from './slices/DCM4CHEE/copyImgSlice';
import getReferringDoctorsSlice from './slices/Appointment/getReferringDoctorsSlice';

import toolButtonToggleSlice from './slices/ToggleTools';
import sendAbhaOtpSlice from './slices/abha/sendAbhaOtp'
import verifyAbhaOtpSlice from './slices/abha/verifyAbhaOtp'

import getPatientAnalyticsSlice from "./slices/analytics/getPatientAnalyticsSlice";
import getReportAnalyticsSlice from './slices/analytics/getReportAnalyticsSlice';
import getAppoitmentAnalyticsSlice from './slices/analytics/getAppoitmentAnalyticsSlice';
import getTurnAroundTimeSlice from './slices/analytics/getTurnAroundTimeSlice';
import getPeerReviewSlice from './slices/analytics/getPeerReviewSlice';
import getRollbackErrorTracking from './slices/analytics/getRollbackErrorTracking';
import getRadiologistPerformanceSlice from './slices/analytics/getRadiologistPerformanceSlice';
import getCalcAvgReportTimeSlice from './slices/analytics/getCalcAvgReportTimeSlice';
import getStratBussiMetrixSlice from './slices/analytics/getStratBussiMetrixSlice';
import getRadiologistCaseRadioSlice from './slices/analytics/getRadiologistCaseRadioSlice';
import getRadiologistDashSlice from './slices/analytics/getRadiologistDashSlice';
import addEditPackageSlice from './slices/billing/addBilling';
import getPackageSlice from './slices/billing/getBilling';
import editPackageSlice from './slices/billing/editBilling';
import deletePackageSlice from './slices/billing/deleteBilling';
import uploadVideoMicroscopySlice from './slices/Microscopy/uploadVideoSlice';
import getInvestigationSlice from './slices/billing/getInvestigation';
import editInvestigationSlice from './slices/billing/editInvestigation';
import deleteInvestigationSlice from './slices/billing/deleteInvestigation';
import assignToSuperadminSlice from "./slices/Microscopy/assignToSuperadminSlice";
import getLabStudiesSlice from './slices/LabStudies/getLabStudiesSlice';
import studyLabAcceptanceStatusSlice from './slices/Patients/studyLabAcceptanceStatus'

import getQualityIndicatorsSlice from './slices/qualityIndicators/index';

import addConsultationChargesSlice from './slices/billing/consultation/addConsultationCharges';
import deleteConsultationChargesSlice from './slices/billing/consultation/deleteConsultationCharges';
import editConsultationChargesSlice from './slices/billing/consultation/editConsultationCharges';
import getConsultationChargesSlice from './slices/billing/consultation/getConsultationCharges';
import getCommonGeneralSettingsSlice from './slices/billing/getCommonGeneralSettings';
import getRadiologistListSlice from './slices/billing/consultation/getRadiologistList';
import addBillingGeneralSettingsSlice from './slices/billing/addBillingGeneralSettings';
import getBillingGeneralSettingsSlice from './slices/billing/getGeneralSettings';
import cancelStudySlice from './slices/teleradiologist/cancelStudy';
import getCancelledStudiesSlice from './slices/teleradiologist/getCancelledStudies'
import getUrgencySlice from './slices/billing/urgency/getUrgency';
import addUrgencySlice from './slices/billing/urgency/addUrgency';
import editUrgencySlice from './slices/billing/urgency/editUrgency';
import getInvoiceSlice from './slices/billing/invoice/getInvoice';
import addInvoiceSlice from './slices/billing/invoice/addInvoice';
import getInvoiceByIdSlice from './slices/billing/invoice/getInvoiceById';
import editInvoiceByIdSlice from './slices/billing/invoice/editInvoiceById';
import downloadInvoiceSlice from './slices/billing/invoice/downloadInvoice';
import refundLaterSlice from './slices/billing/invoice/refundLater';
import getAnalyticsSlice from './slices/billing/analytics/getAnalytics';
import deleteUrgencySlice from './slices/billing/urgency/deleteUrgency';
import changeReviewStudyStatusSlice from './slices/teleradiologist/changeReviewStatusSlice';
import deleteReviewStudyStatusSlice from './slices/teleradiologist/deleteReviewStatusSlice'
import checkHospitalCreditSlice from './slices/teleradiologist/checkHospitalCredit';
import appointmentDetailbyUIDSlice from './slices/Appointment/getAppointmentsbyUID'
import appointmentDetailbyPatientIdSlice from './slices/Appointment/getAppointmentByPatientId'

import getCaseTimingSlice from './slices/Setting/getCaseTimingSlice';
import addCaseTimingSlice from './slices/Setting/addCaseTimingSlice';
import updateCaseTimingSlice from './slices/Setting/updateCaseTimingSlice';
import getDoctorDiscountSlice from './slices/billing/doctorDiscount/getDoctorDiscount';
import addDoctorDiscountSlice from './slices/billing/doctorDiscount/addDoctorDiscount';
import deleteDoctorDiscountSlice from './slices/billing/doctorDiscount/deleteDoctorDiscount';
import editDoctorDiscountSlice from './slices/billing/doctorDiscount/editDoctorDiscount';
import getSuperadminDetailsSlice from './slices/masterSuperadminProfile/getSuperadminDetail';
import masterSuperAdminChangePasswordSlice from './slices/masterSuperadminProfile/changePassword';
import addSuperadminDetailsSlice from './slices/masterSuperadminProfile/addSuperadminDetails';

import billingAuditListSlice from './slices/Audit/billingAuditSlice';
import teleradiologistAuditLogsSlice from './slices/Audit/teleradiologistAuditLogs';

import addTeleModPriceSlice from './slices/Setting/addTeleModPriceSlice';
import getTeleModPriceSlice from './slices/Setting/getTeleModPriceSlice';
import editTeleModPriceSlice from './slices/Setting/editTeleModPriceSlice';
import deleteTeleModPriceSlice from './slices/Setting/deleteTeleModPriceSlice';

import editHospitalTeleModPriceSlice from './slices/hospital/editHospitalTeleCredit'

import getTeleServicePriceSlice from './slices/Setting/getTeleServicePriceSlice';
import addTeleServicePriceSlice from './slices/Setting/addTeleServicePriceSlice';
import editTeleServicePriceSlice from './slices/Setting/editTeleServicePriceSlice';
import deleteTeleServicePriceSlice from './slices/Setting/deleteTeleServicePriceSlice';

import teleradiologistPayoutsSlice from './slices/teleradiologistPayouts';

import odooApprovedSlice from './slices/hospital/odooApproved';

import getPlansSlice from './slices/Setting/plans/getPlanSlice';
import updatePlansSlice from './slices/Setting/plans/updatePlanSlice';

import createStripePortalSessionSlice from './slices/payementGateway/createPortalSessionSlice';
import addOnSelectionSlice from './slices/hospital/addOnSelection';

import updateAddonsSlice from './slices/Setting/addOns/updateAddonsSlice';
import getAddonsSlice from './slices/Setting/addOns/getAddonsSlice';

import addCaseCreditSlice from './slices/Setting/creditForCaseToCase/addCaseCreditSlice';
import getCaseCreditSlice from './slices/Setting/creditForCaseToCase/getCaseCreditsSlice';
import updateCaseCreditSlice from './slices/Setting/creditForCaseToCase/updateCaseCreditSlice';
import deleteCaseCreditSlice from './slices/Setting/creditForCaseToCase/deleteCaseCreditSlice';

import getCreditPerGbDetailsSlice from './slices/masterSuperadminProfile/getCreditPerGbDetailsSlice';
import addEditCreditPerGbSlice from './slices/masterSuperadminProfile/addEditCreditPerGbSlice';

import requestDiscountSlice from './slices/billing/discoutNotification/requestDiscount';
import getDiscountRequestsSlice from './slices/billing/discoutNotification/getDiscountRequests';
import changeDiscountStatusSlice from './slices/billing/discoutNotification/changeDiscountStatus';

import deductCreditForStorageSlice from './slices/payementViaCredit/deductCreditForStorageSlice'
import getInvoiceDiscountRequestSlice from './slices/billing/doctorDiscount/invoiceWithDiscountRequest';

import switchRoleSlice from './slices/user/switchRole';

import generatePdfSlice from './slices/Appointment/generatePDF';
import getExtraStorageSlice from "./slices/Setting/extraStorage/getExtraStorageSlice";
import updateExtraStorageSlice from "./slices/Setting/extraStorage/updateExtraStorageSlice";

import moveToExtraStorageSlice from "./slices/extraStorage/moveToExtraStorageSlice";
import switchPathologyStudyStorageSlice from "./slices/Microscopy/switchPathologyStudyStorage";
import pathologyAIStudiesSlice from "./slices/Microscopy/pathologyAIStudiesSlice";
import retriggerPathologyAISlice from "./slices/Microscopy/retriggerPathologyAISlice";
import pathologyAIResultsSlice from "./slices/Microscopy/pathologyAIResultsSlice";
import subscribedStudiesSlice from './slices/Subscription/subscribedStudiesSlics';
import subscribedStatusSlice from './slices/Subscription/subscribedStatusSlice';

import checkSpeechToTextUserSlice from "./slices/speechToText/checkSpeechToTextUserSlice";

import editHospitalCaseCreditSlice from './slices/Setting/creditForCaseToCase/updateHospitalCaseCreditSlice';

import getHospitalCaseCreditsSlice from './slices/Setting/creditForCaseToCase/getHospitalCaseCredit';

import getCaseToCaseHospitalSlice from './slices/Setting/creditForCaseToCase/getCaseToCaseHospital';
import getGiftCardsSlice from './slices/hospital/getGiftCardsSlice';

import sendPayementLinkSlice from './slices/Subscription/sendPayementLinkSlice';

import EnrollABHAviaAadhaarSlice from './slices/abha/enrollViiaAadhaar';
import VerifyOtpAndEnrollSlice from './slices/abha/verifyOtpAndEnrollSlice';

import predictFractureSlice from './slices/aiServices/predictFractureSlice';
import predictHemorrhageSlice from './slices/aiServices/predictHemorrhageSlice';
import getAIStudiesSlice from './slices/Appointment/getAIStudies';

// @ts-ignore
const store = configureStore({
  reducer: {
    patientListResponse: patientlistSlice,
    patientdetailResponce: patientdetailSlice,
    studyLabAcceptanceStatusResponse: studyLabAcceptanceStatusSlice,
    addEditApointmentResponse: addEditAppointmentSlice,
    loginResponse: loginSlice,
    forgotPassword: forgotPassword,
    verifyEmail: verifyEmail,
    resetPassword: resetPassword,
    kcDcmTokenResponse: kcDcmTokenSlice,
    localKcDcmTokenResponse: localKcDcmTokenSlice,
    latestModalityResponse: latestModalitySlice,
    prescriptionListResponse: prescriptionListSlice,
    prescriptionUploadResponse: prescriptionUploadSlice,
    prescriptionDeleteResponse: prescriptionDeleteSlice,
    healthcareUpdateResponse: healthcareUpdateSlice,
    patientStudiesResponse: patientStudiesSlice,
    getUserDetails: getUserDetails,
    changePasswordResponse: changePasswordSlice,
    updateProfile: updateProfile,
    auditListResponse: auditListSlice,
    updateProfileResponse: updateProfile,
    hospitalDetailsResponse: hospitalDetails,
    PreviousAppointmentresponce: preappointmentSlice,
    Rollbackresponce: reportSlice,
    RollbackListresponce: rollbackListSlice,
    toggleOverlay: toggleOverlaySlice,
    appointmentDetailResponse: appointmentDetailSlice,
    getReportIdResponse: getReportIdSlice,
    updateTags: updateTags,
    ActiveMachinelistSliceResponse: ActiveMachinelistSlice,
    addActiveMachineSliceSlice: addActiveMachineSlice,
    teleraidologyCustomerSlice: teleraidologyCustomerSlice,
    studyDataResponse: studyDataSlice,
    studyResearchList: listStudyResearchSlice,
    updateStudyResearch: updateStudyResearchSlice,
    addStudyReserach: addStudyResearchSlice,
    discardReportResponse: discardReportSlice,
    teleraidologySliceResponce: teleraidologySlice,
    reportsSettingsResponse: reportsSettingsSlice,
    updateProfileImageResponse: updateProfileImageSlice,
    submitReportsSettingsFormResponse: submitReportsSettingsForm,
    duplicateStudyResponse: duplicateStudySlice,
    radiologiestUserSliceresponce: radiologiestUserSlice,
    sendReviewSliceResponce: sendReviewSlice,
    reviewSliceResponce: reviewSlice,
    sendBackSliceResponce: sendBackSlice,
    reportImageSelector:reportImageSelectionSlice,
    aiImageSelector:aiImageSelectionSlice,
    getRadiologistUserResponse: getRadiologistUserSlice,
    assignRadiologistResponse: assignRadiologistSlice,
    teleradiologistResponse: teleradiologistSlice,
    dashboardResponse: dashboardSlice,
    getRollbackReportSliceResponce: getRollbackReportSlice,
    getAllReportSliceResponce: getAllReportSlice,
    shareReportWhatsappSliceResponse: shareReportWhatsappSlice,
    userListResponse: userListSlice,
    deleteUserResponse: deleteUserSlice,
    deletePatientResponse: deletePatientSlice,
    addEditPACResponse: addEditPACSlice,
    createIsoImageResponse: createIsoImageSlice,
    deleteMachineSliceResponce: deleteMachineSlice,
    getSharedReportSlice: getSharedReportSlice,
    machineApiSliceResponse: machineApiSlice,
    getMachineListApiSliceResponse: getMachineListApiSlice,
    deleteSelectedMachineSliceResponse: deleteSelectedMachineSlice,
    EditMachineApiSliceResponse: EditMachineApiSlice,
    getDeviceNameSliceResponse: getDeviceNameSlice,
    deactivateUserSliceResponse: deactivateUserSlice,
    activateUserSliceResponse: activateUserSlice,
    deactivatePatientSliceResponse: deactivatePatientSlice,
    activatePatientSliceResponse: activatePatientSlice,
    deactivateRadiologistUserSliceResponse: deactivateRadiologistUserSlice,
    uploadReportImgsResponse: uploadReportImgsSlice,
    uploadImageMicroscopyResponse: uploadImageMicroscopySlice,
    uploadVideoMicroscopyResponse: uploadVideoMicroscopySlice,
    patientMicroscopyDetailResponse: patientMicroscopyDetailSlice,
    dwnldImgIds: dwnldImgSlice,
    generateStudyLinkResponse : geneateStudyLinkSlice,
    verifyStudyLinkResponse : verifyStudyLinkSlice,
    pathologiestUserSliceResponse: pathologistUserSlice,
    assignPathologistResponse: assignPathologistSlice,
    saveMicroscopyMeasurementsResponse: saveMicroscopyMeasurementsSlice,
    getMicroscopyMeasurementsResponse: getMicroscopyMeasurementsSlice,
    updateMicroscopyMeasurementsResponse: updateMicroscopyMeasurementsSlice,
    toolButtonToggleResponse: toolButtonToggleSlice,
    deleteMicroscopyAnnotationResponse: deleteMicroscopyAnnotationSlice,
    copyImgToClipboard : copyImgSlice,
    addEditPriceSliceResponse: addEditPriceSlice,
    editPriceSliceResponse: editPriceSlice,
    getPriceSliceResponse: getPriceSlice,
    addEditModalityStudySliceResponse: addEditModalityStudySlice,
    getModalityStudySliceResponse: getModalityStudySlice,
    getModifiedCreditHospitalsSliceResponse: getModifiedCreditHospitalsSlice,
    deletePriceSliceResponse: deletePriceSlice,
    redoScanSliceResponse: redoScanSlice,
    deletePreviewImageSliceResponse: deletePreviewImageSlice,
    addRedoReasonResponse: addRedoReasonSlice,
    getAppointmentStudyResponse: getAppointmentStudySlice,
    getNotificationCountResponse: getNotificationCountSlice,
    saveProcessedReportsResponse: saveProcessedReportsSlice,
    previewReportDownloadResponse: previewReportDownloadSlice,
    sendAbhaOtpResponse: sendAbhaOtpSlice,
    verifyAbhaOtpReponse: verifyAbhaOtpSlice,
    updateReportResponse: updateReportSlice,
    getReferringDoctorsSliceResponse: getReferringDoctorsSlice,
    getPatientAnalyticsResponse: getPatientAnalyticsSlice,
    getReportAnalyticsResponse: getReportAnalyticsSlice,
    getAppoitmentAnalyticsResponse: getAppoitmentAnalyticsSlice,
    getTurnAroundTimeResponse: getTurnAroundTimeSlice,
    getPeerReviewResponse: getPeerReviewSlice,
    getRollbackErrorTrackingResponse: getRollbackErrorTracking,
    getRadiologistPerformanceResponse: getRadiologistPerformanceSlice,
    getCalcAvgReportTimeResponse: getCalcAvgReportTimeSlice,
    getStratBussiMetrixResponse: getStratBussiMetrixSlice,
    getRadiologistCaseRadioResponse: getRadiologistCaseRadioSlice,
    getRadiologistDashResponse: getRadiologistDashSlice,
    addEditPackageResponse: addEditPackageSlice,
    getPackageResponse: getPackageSlice,
    editPackageResponse: editPackageSlice,
    deletePackageResponse: deletePackageSlice,
    getLabStudiesResponse: getLabStudiesSlice,
    getQualityIndicatorsResponse: getQualityIndicatorsSlice,

    addConsultationChargesResponse: addConsultationChargesSlice,
    deleteConsultationChargesResponse: deleteConsultationChargesSlice,
    editConsultationChargesResponse: editConsultationChargesSlice,
    getConsultationChargesResponse: getConsultationChargesSlice,
    getCommonGeneralSettingsResponse: getCommonGeneralSettingsSlice,
    getRadiologistListResponse: getRadiologistListSlice,
    addBillingGeneralSettingsResponse: addBillingGeneralSettingsSlice,
    getBillingGeneralSettingsSliceResponse: getBillingGeneralSettingsSlice,
    getInvestigationResponse: getInvestigationSlice,
    editInvestigationResponse: editInvestigationSlice,
    deleteInvestigationResponse: deleteInvestigationSlice,
    getUrgencyResponse: getUrgencySlice,
    addUrgencyResponse: addUrgencySlice,
    editUrgencyResponse: editUrgencySlice,
    deleteUrgencyResponse: deleteUrgencySlice,
    getInvoiceResponse: getInvoiceSlice,
    addInvoiceResponse: addInvoiceSlice,
    getInvoiceByIdResponse: getInvoiceByIdSlice,
    editInvoiceByIdResponse: editInvoiceByIdSlice,
    downloadInvoiceResponse: downloadInvoiceSlice,
    refundLaterResponse: refundLaterSlice,
    getAnalyticsResponse: getAnalyticsSlice,
    verifyReportResponse :verifyReportSlice,
    verifyTelepathologyReportResponse :verifyTelepathologyReportSlice,
    assignToSuperadminResponse :assignToSuperadminSlice,
    cancelStudyResponse: cancelStudySlice,
    getCancelledStudiesResponse: getCancelledStudiesSlice,
    getCaseTimingResponse: getCaseTimingSlice,
    addCaseTimingResponse: addCaseTimingSlice,
    updateCaseTimingResponse: updateCaseTimingSlice,

    getDoctorDiscountResponse: getDoctorDiscountSlice,
    addDoctorDiscountResponse: addDoctorDiscountSlice,
    deleteDoctorDiscountResponse: deleteDoctorDiscountSlice,
    editDoctorDiscountResponse: editDoctorDiscountSlice,

    changeReviewStudyStatusResponse:changeReviewStudyStatusSlice,
    appointmentDetailbyUIDresponse:appointmentDetailbyUIDSlice,
    appointmentDetailbyPatientIdResponse:appointmentDetailbyPatientIdSlice,

    billingAuditListResponse: billingAuditListSlice,
    getSuperadminDetailsResponse: getSuperadminDetailsSlice,
    masterSuperAdminChangePasswordResponse: masterSuperAdminChangePasswordSlice,
    addSuperadminDetailsResponse: addSuperadminDetailsSlice,

    deleteReviewStudyStatusResponse:deleteReviewStudyStatusSlice,
    checkHospitalCreditResponse: checkHospitalCreditSlice,
    teleradiologistAuditLogsResponse: teleradiologistAuditLogsSlice,

    getTeleModPriceSliceResponse: getTeleModPriceSlice,
    addTeleModPriceSliceResponse: addTeleModPriceSlice,
    editTeleModPriceSliceResponse: editTeleModPriceSlice,
    deleteTeleModPriceSliceResponse: deleteTeleModPriceSlice,

    editHospitalTeleModPriceSliceResponse :editHospitalTeleModPriceSlice,

    getTeleServicePriceSliceResponse: getTeleServicePriceSlice,
    addTeleServicePriceSliceResponse: addTeleServicePriceSlice,
    editTeleServicePriceSliceResponse: editTeleServicePriceSlice,
    deleteTeleServicePriceSliceResponse: deleteTeleServicePriceSlice,

    teleradiologistPayoutsResponse: teleradiologistPayoutsSlice,

    odooApprovedResponse: odooApprovedSlice,
    getPlansResponse: getPlansSlice,
    updatePlansResponse: updatePlansSlice,
    createStripePortalSessionResponse:createStripePortalSessionSlice,

    requestDiscountResponse: requestDiscountSlice,
    getDiscountRequestsResponse: getDiscountRequestsSlice,
    changeDiscountStatusResponse: changeDiscountStatusSlice,

    addOnSelectionResponse: addOnSelectionSlice,

    updateAddonsResponse: updateAddonsSlice,
    getAddonsResponse: getAddonsSlice,

    addCaseCreditResponse: addCaseCreditSlice,
    getCaseCreditResponse: getCaseCreditSlice,
    updateCaseCreditResponse: updateCaseCreditSlice,
    deleteCaseCreditResponse: deleteCaseCreditSlice,

    addEditCreditPerGbResponse: addEditCreditPerGbSlice,
    getCreditPerGbDetailsResponse: getCreditPerGbDetailsSlice,

    deductCreditForStorageResponse: deductCreditForStorageSlice,

    // Extra Storage
    getExtraStorageResponse: getExtraStorageSlice,
    updateExtraStorageResponse: updateExtraStorageSlice,
    getInvoiceDiscountRequestResponse: getInvoiceDiscountRequestSlice,

    switchRoleResponse: switchRoleSlice,

    generatePdfResponse: generatePdfSlice,

    moveToExtraStorageResponse: moveToExtraStorageSlice,
    switchPathologyStudyStorageResponse: switchPathologyStudyStorageSlice,
    subscribedStudiesSliceResponse:subscribedStudiesSlice,
    checkSpeechToTextUserSliceResponse: checkSpeechToTextUserSlice,

    editHospitalCaseCreditResponse: editHospitalCaseCreditSlice,
    getHospitalCaseCreditsResponse: getHospitalCaseCreditsSlice,
    getCaseToCaseHospitalResponse: getCaseToCaseHospitalSlice,
    subscribedStatusSliceResponse:subscribedStatusSlice,

    // Gift cards
    getGiftCardsSliceResponse: getGiftCardsSlice,

    sendPayementLinkSliceResponse: sendPayementLinkSlice,

    EnrollABHAviaAadhaarResponse: EnrollABHAviaAadhaarSlice,
    VerifyOtpAndEnrollResponse: VerifyOtpAndEnrollSlice,

    predictFractureResponse: predictFractureSlice,
    predictHemorrhageResponse: predictHemorrhageSlice,
    getAIStudiesResponse: getAIStudiesSlice,

    pathologyAIStudiesResponse: pathologyAIStudiesSlice,
    retriggerPathologyAIResponse: retriggerPathologyAISlice,
    pathologyAIResultsResponse: pathologyAIResultsSlice,
  }
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

export default store;
